import axios from 'axios'
import axiosRetry from 'axios-retry'
import tokenManager from '@/services/tokenManager'

axios.defaults.headers.common['Authorization'] = `Bearer ${tokenManager.token}`
axiosRetry(axios, { retryDelay: (retryCount) => retryCount * 1000 })

const AUTH_API = process.env.AUTH_API_URL
const SURVEY_API = process.env.SURVEY_API_URL

const config = {
  headers: {
    'Accept': 'application/ld+json',
    'Cache-Control': 'no-transform'
  }
}

const users = {

  async fetch () {
    return axios.get(`${AUTH_API}/users`, {
      config
    })
  },

  async fetchOne (id) {
    return axios.get(`${AUTH_API}/users/${id}`, {
      config
    })
  },

  async create (user) {
    return axios.post(`${AUTH_API}/users`, user, {
      config
    })
  },

  async update (id, user) {
    return axios.put(`${AUTH_API}/users/` + id, user, {
      config
    })
  },

  async delete (id) {
    return axios.delete(`${AUTH_API}/users/${id}`, {
      config
    })
  }

}

const customers = {
  async fetch () {
    return axios.get(`${AUTH_API}/customers`, {
      config
    })
  }
}

const auth = {
  updateToken (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  connectAs (userId) {
    return axios.get(`${AUTH_API}/users/${userId}/token`, {
      config
    })
  }
}

const productData = {
  fetchSurveys () {
    return axios.get(`${SURVEY_API}/Surveys`, {
      config,
      params: {
        filter: {
          fields: {
            userId: true,
            createdAt: true
          }
        },
        fetchUserRelatedData: false
      }
    })
  }
}

export { users, customers, auth, productData }



// WEBPACK FOOTER //
// ./src/api/index.js